<template>
  <div class="Field__Component">
    <label for="" class="Field__Component__Label">
      <span><slot></slot></span>
      <div class="is-flex Field__Component__Label__Date">
        <b-datepicker
          :diabled="true"
          v-model="fromDate"
          @input="setSelected('from')"
          placeholder="תאריך התחלה"
          icon-prev="chevron-right"
          append-to-body
          icon-next="chevron-left"
          icon="calendar-today"
          locale="en-GB"
          :day-names="['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']"
          :month-names="[
            'ינואר',
            'פברואר',
            'מרץ',
            'אפריל',
            'מאי',
            'יוני',
            'יולי',
            'אוגוסט',
            'ספטמבר',
            'אוקטובר',
            'נובמבר',
            'דצמבר',
          ]"
          close-on-click
          :position="position ? position : 'is-bottom-left'"
          editable
        >
        </b-datepicker>
        <b-datepicker
          v-model="toDate"
          @input="setSelected('to')"
          placeholder="תאריך סיום"
          icon-prev="chevron-right"
          append-to-body
          icon-next="chevron-left"
          icon="calendar-today"
          locale="en-GB"
          :min-date="fromDate || null"
          :day-names="['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']"
          :month-names="[
            'ינואר',
            'פברואר',
            'מרץ',
            'אפריל',
            'מאי',
            'יוני',
            'יולי',
            'אוגוסט',
            'ספטמבר',
            'אוקטובר',
            'נובמבר',
            'דצמבר',
          ]"
          close-on-click
          :position="position ? position : 'is-bottom-left'"
          editable
        >
        </b-datepicker>
      </div>
    </label>
  </div>
</template>

<script>
import moment from "moment";
// import vSelect from "vue-select";
// import "vue-select/src/scss/vue-select.scss";

export default {
  name: "FilterDateTypes",
  props: ["value", "options", "optionsAsync", "clearable"],
  components: {
    // vSelect,
  },
  computed: {
    sortedList() {
      if (this.data) {
        const clone = this.data;
        return clone.sort(this.sort);
      }
      return [];
    },
  },
  data() {
    return {
      data: [],
      fromDate: this.value?.fromDate
        ? this.timeToTimepicker(this.value.fromDate)
        : null,
      toDate: this.value?.toDate
        ? this.timeToTimepicker(this.value.toDate)
        : null,
      position: null,
    };
  },
  created() {
    if (this.options[0].preSettedDate) {
      // for default sets
      if (!this.toDate) {
        this.toDate = this.timeToTimepicker(
          this.options[0].preSettedDate.endDate
        );
      }
      this.setSelected(this.options[0].preSettedDate.value);
      this.position = this.options[0].preSettedDate.position;
    }
    if (this.optionsAsync) {
      this.optionsAsync().then((r) => {
        this.data = r;
      });
    } else {
      this.data = this.options.slice(0);
    }
  },
  methods: {
    timeToTimepicker(time) {
      const targetTime = new Date(time);
      const tzDifference = targetTime.getTimezoneOffset();
      return new Date(targetTime.getTime() + tzDifference * 60 * 1000);
    },
    setSelected(value) {
      const obj = { ...this.value };
      if (value === "from") {
        // Clearing the picker must clear the bound field, not send "Invalid date".
        obj.fromDate = this.fromDate
          ? moment(this.fromDate).utcOffset(0, true).format("YYYY-MM-DD")
          : null;
      } else if (value === "to") {
        obj.toDate = this.toDate
          ? moment(this.toDate).utcOffset(0, true).format("YYYY-MM-DD")
          : null;
      } else {
        obj.Value = value;
      }
      // The parent resolves fromField/toField by matching model.Value against Options,
      // so a range filter still needs a Value even though the dates drive the query.
      // Single-option filters (the common case) pin it to that option.
      if (obj.Value == null && this.options && this.options.length === 1) {
        obj.Value = this.options[0].Value;
      }
      this.$emit("input", obj);
    },
    sort(a, b) {
      return a.Text - b.Text;
    },
  },
};
</script>
<style scoped lang="scss">
.Field__Component__Label__Date {
  gap: 8px;

  > div {
    // Two pickers share the row; without a zero basis the flex items overflow
    // the filter panel and push the dropdown off-screen.
    flex: 1 1 0;
    min-width: 0;
    width: 100%;
    margin: 15px 0;
  }
}
</style>
